import script from "./MainStructure.vue?vue&type=script&setup=true&lang=js"
export * from "./MainStructure.vue?vue&type=script&setup=true&lang=js"

import "./MainStructure.vue?vue&type=style&index=0&id=6a1afce8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6a1afce8"]])

export default __exports__